import ReactLoading from 'react-loading';
import { useState } from 'react';
import { standardDate } from '../../../../utils/formatDate';
import DeleteIcon from '../../../../assets/icons/trvto_deleteIcon.svg';
import Dialog from '../../../dialogModal/dialogModal';

const DatesDetails = ({ dates, deleteUnavailableDate, setDateToDelete, deleteModal, setDeleteModal, loading }) => {
    const [addBo, setAddBo] = useState(false);
    const sortedDates = dates?.sort((a, b) => new Date(a) - new Date(b));

    return (
        <div>
            <div className='orgDateTabBtnDiv'>
                <button
                    className={'orgDateTabUpCo blueBtn'}
                    onClick={() => {
                        setAddBo(true);
                    }}
                >
                    Add Booking
                </button>
            </div>
            {loading ? (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            ) : (
                <table className='orgDatesTabTable'>
                    <thead className='orgDatesTabHead'>
                        <tr>
                            <th>Unavailable Date</th>
                            <th>Action</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDates?.map((row, rowKey) => {
                            return (
                                <tr key={rowKey} className='orgDatesTabRow'>
                                    <td>{standardDate(row.split('T')[0]) ?? 'N/A'}</td>
                                    <td>
                                        <button
                                            className='deleteBtn'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setDeleteModal(true);
                                                setDateToDelete(row);
                                            }}
                                        >
                                            <img src={DeleteIcon} alt='trvto_delete' />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
            {deleteModal && (
                <Dialog openModal={deleteModal} heading={'Delete Confirmation!'}>
                    <div className='dialogContent'>
                        <p className='confirmationText'>Are you sure?</p>
                        <p className='confirmationMessage'>You want to delete this Date.</p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn submit' onClick={deleteUnavailableDate}>
                                Yes
                            </button>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default DatesDetails;
